import { DMS_CUSTOM_QUERY_HISTORY_STATUSES } from "models";

import type { TFunction } from "i18next";

type StatusName = { label: string; defaultText: string };

const STATUS_NAME: Record<DMS_CUSTOM_QUERY_HISTORY_STATUSES, StatusName> = {
  [DMS_CUSTOM_QUERY_HISTORY_STATUSES.Pending]: { label: "v8_pending", defaultText: "Pending" },
  [DMS_CUSTOM_QUERY_HISTORY_STATUSES.Executed]: { label: "v8_executed", defaultText: "Executed" },
  [DMS_CUSTOM_QUERY_HISTORY_STATUSES.Error]: { label: "v8_error", defaultText: "Error" }
};

export const getStatusName = (t: TFunction, status: DMS_CUSTOM_QUERY_HISTORY_STATUSES) => {
  const { label, defaultText } = STATUS_NAME[status];
  return t(label, defaultText);
};

const MAX_COLUMN_WIDTH = 400;

export const autoColumnWidth = <T extends Record<string, unknown>>(rows: T[], accessor: keyof T, headerText: string) => {
  const cellLength = Math.max(...rows.map(row => `${row[accessor] ?? ""}`.length), headerText.length);
  const cellSpacing = cellLength < 10 ? cellLength * 15 : cellLength * 10;
  return Math.min(MAX_COLUMN_WIDTH, cellSpacing);
};
